import { Color } from "../maths/Color";
import { MathUtil } from "../maths/MathUtil";
import { Rectangle } from "../maths/Rectangle";
import { Vector2 } from "../maths/Vector2";
import { Pool } from "./Pool";
export class VertexStream {
    constructor() {
        this._vp = 0;
        this._ip = 0;
        this.contentRect = new Rectangle();
        this.uvRect = new Rectangle();
        this.color = new Color();
        this._vertices = this.resizeBuf(Float32Array, 20);
        this._uvs = this.resizeBuf(Float32Array, 20);
        this._colors = this.resizeBuf(Float32Array, 40);
        this._indices = this.resizeBuf(Uint16Array, 30);
        this._vec = new Vector2();
    }
    init(mainTex) {
        this.mainTex = mainTex;
        if (mainTex) {
            let uv = mainTex.uvrect;
            if (mainTex.width === mainTex.sourceWidth && mainTex.height === mainTex.sourceHeight)
                this.uvRect.setTo(uv[0], uv[1], uv[2], uv[3]);
            else {
                let sx = uv[2] / mainTex.width;
                let sy = uv[3] / mainTex.height;
                this.uvRect.setTo(uv[0] - mainTex.offsetX * sx, uv[1] - mainTex.offsetY * sy, mainTex.sourceWidth * sx, mainTex.sourceHeight * sy);
            }
        }
        else
            this.uvRect.setTo(0, 0, 1, 1);
        this.color.setValue(1, 1, 1, 1);
        this._vp = 0;
        this._ip = 0;
    }
    addVert(x, y, color, u, v) {
        this.checkVBuf(2);
        let idx = this._vp;
        this._vp += 2;
        this._vertices[idx] = x;
        this._vertices[idx + 1] = y;
        if (u != null)
            this._uvs[idx] = u;
        else
            this._uvs[idx] = MathUtil.lerp(this.uvRect.x, this.uvRect.right, (x - this.contentRect.x) / (this.contentRect.width || 1));
        if (v != null)
            this._uvs[idx + 1] = v;
        else
            this._uvs[idx + 1] = MathUtil.lerp(this.uvRect.y, this.uvRect.bottom, (y - this.contentRect.y) / (this.contentRect.height || 1));
        (color || this.color).writeTo(this._colors, idx * 2);
    }
    addQuad(rect, color, uvRect) {
        if (uvRect) {
            this.addVert(rect.x, rect.y, color, uvRect.x, uvRect.y);
            this.addVert(rect.right, rect.y, color, uvRect.right, uvRect.y);
            this.addVert(rect.right, rect.bottom, color, uvRect.right, uvRect.bottom);
            this.addVert(rect.x, rect.bottom, color, uvRect.x, uvRect.bottom);
        }
        else {
            this.addVert(rect.x, rect.y, color);
            this.addVert(rect.right, rect.y, color);
            this.addVert(rect.right, rect.bottom, color);
            this.addVert(rect.x, rect.bottom, color);
        }
    }
    addTriangle(idx0, idx1, idx2) {
        this.checkIBuf(3);
        let idx = this._ip;
        this._ip += 3;
        this._indices[idx] = idx0;
        this._indices[idx + 1] = idx1;
        this._indices[idx + 2] = idx2;
    }
    addTriangles(indices) {
        this.checkIBuf(indices.length);
        let arr = this._indices;
        let idx = this._ip;
        let n = indices.length;
        this._ip += n;
        for (let i = 0; i < n; i++)
            arr[idx + i] = indices[i];
    }
    triangulateQuad(baseIndex) {
        let cnt = this._vp / 2;
        if (baseIndex < 0)
            baseIndex = cnt + baseIndex;
        let icnt = (cnt - baseIndex) / 4 * 6;
        this.checkIBuf(icnt);
        let arr = this._indices;
        for (let i = baseIndex, j = this._ip; i < cnt; i += 4, j += 6) {
            arr[j] = i;
            arr[j + 1] = i + 1;
            arr[j + 2] = i + 2;
            arr[j + 3] = i + 2;
            arr[j + 4] = i + 3;
            arr[j + 5] = i;
        }
        this._ip += icnt;
    }
    getPos(index) {
        if (index < 0)
            index = this._vp / 2 + index;
        index *= 2;
        this._vec.setValue(this._vertices[index], this._vertices[index + 1]);
        return this._vec;
    }
    get vertCount() {
        return this._vp / 2;
    }
    getVertices() {
        return new Float32Array(this._vertices.buffer, 0, this._vp);
    }
    getUVs() {
        return new Float32Array(this._uvs.buffer, 0, this._vp);
    }
    getColors() {
        return new Float32Array(this._colors.buffer, 0, this._vp * 2);
    }
    getIndices() {
        return new Uint16Array(this._indices.buffer, 0, this._ip);
    }
    checkVBuf(addCount) {
        if (this._vp + addCount < this._vertices.length)
            return;
        let vp = this._vp + Math.max(20, addCount);
        this._vertices = this.resizeBuf(Float32Array, vp, this._vertices);
        this._uvs = this.resizeBuf(Float32Array, vp, this._uvs);
        this._colors = this.resizeBuf(Float32Array, vp * 2, this._colors);
    }
    checkIBuf(addCount) {
        if (this._ip + addCount < this._indices.length)
            return;
        let ip = this._ip + Math.max(30, addCount);
        this._indices = this.resizeBuf(Uint16Array, ip, this._indices);
    }
    resizeBuf(type, sz, oldData) {
        let newBuf = new ArrayBuffer(type.BYTES_PER_ELEMENT * sz);
        let newDataView = new type(newBuf);
        oldData && newDataView.set(oldData);
        return newDataView;
    }
}
VertexStream.pool = Pool.createPool(VertexStream, (e, mainTex) => e.init(mainTex));
